import { getHttpClient } from '../core/httpClient';
import type { Product } from '../types';

export class ProductsService {
  async list(): Promise<Product[]> {
    const client = getHttpClient();
    return client.get<Product[]>('/public/products');
  }

  async get(productId: string): Promise<Product> {
    const client = getHttpClient();
    return client.get<Product>(`/public/products/${productId}`);
  }
}

export const productsService = new ProductsService();

